import React, { useState } from "react";
import useForm from './form'
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './style.module.css'
import ApiConfig from '../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../utils/hooks';

function AddTask(props) {

    var task = {
      Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      Name: "",
      Type: "",
      Command: "",
      Deleted: false,
      CreatedBy: "system",
      UpdatedBy: "system",
    }

  const formSubmit = () => {

    console.log("Callback function when form is submitted!");
    console.log("Form Values ", values);
    task.Name = values.Name
    task.Type = values.Type
    task.Command = values.Command
    props.addTask(task)
    props.handleClose()
    handleClose()
  }
  const {handleChange, values,handleClose} = useForm(formSubmit);

    return(
      <Modal
        open={props.openAddTask}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box component="form" onSubmit={formSubmit} sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',
            height: '50%',
            bgcolor: 'background.paper',
            border: '2px solid',
            borderColor: 'divider',
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
            overflowY: "auto"
          }}>
          <Typography variant="h6" gutterBottom>
              Create New Task
          </Typography>
          <TextField
              required
              fullWidth
              label="Task Name"
              defaultValue=""
              name="Name"
              onChange={handleChange}
              margin="normal"
          />
          <TextField
              required
              fullWidth
              label="Task Type"
              defaultValue=""
              name="Type"
              onChange={handleChange}
              margin="normal"
          />
          <TextField
              required
              fullWidth
              label="Command"
              defaultValue=""
              name="Command"
              onChange={handleChange}
              margin="normal"
          />
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
              Submit
          </Button>
          </Box>
      </Modal>
    )
  }


function Tasks(props) {
    const { keycloak } = useKeycloak();
    const a = new ApiConfig(keycloak)
    const apiConfig = a.api()

    const [openAddTask, setOpenAddTask] = useState(false);
    const handleAddTaskClose = () => setOpenAddTask(false);
    const handleAddTaskOpen = () => setOpenAddTask(true);

    const [tasks, setTasks] = useState([])
    const [task_expanded, setTaskExpanded] = useState(false);
    const [taskFormData, setTaskFormData] = useState({
        Name: '',
        Type: '',
        Command: '',
        Deleted: false,
        UpdatedBy: 'system',
    });
    const handleTaskExpandedChange = (panel, task) => (event, isExpanded) => {
        setTaskExpanded(isExpanded ? panel : false);
        setTaskFormData(task)
    };
    const handleTaskFormSubmit = (e) => {
        e.preventDefault();
        apiConfig.updateTask(taskFormData.Id, taskFormData).then((response)=>{
            console.log(response)
            retrieveTasks()
        })
        console.log('Task Form Data Submitted:', taskFormData);
    };

    const handleTaskFormChange = (e) => {
        const { name, value } = e.target;
        setTaskFormData({
            ...taskFormData,
            [name]: value
        });
    };

    const retrieveTasks = () => {
        // setTasks([])
        // setTasklists([])
        // setMissions([])
        Promise.all([
          apiConfig.fetchTaskInfo(),
        ]).then(results => {
            // console.log(results[0].RobotResponse)
            // console.log(results[1].RobotResponse)
            // console.log(results[2].RobotResponse)
            setTasks(results[0].RobotResponse)
        }).catch(error => {
            console.error(error);
        });
      }

    useMountEffect(() => {
        // console.log(props)
        retrieveTasks()
        return () => {
            // This code runs when the component is unmounted
            // Perform cleanup or unsubscribe from resources
            // console.log("Disconnecting from websocket...")
            // socket.close()
        };

    }, []);

    const renderTasks = (task, index) => {
        return(
            <Accordion key={index} expanded={task_expanded === task.Id} onChange={handleTaskExpandedChange(task.Id, task)}>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                >
                <Typography sx={{ width: '100%', flexShrink: 0 }}>
                    {task.Name}
                </Typography>
                {/* <Typography sx={{ color: 'text.secondary' }}>{task.Command}</Typography> */}
                </AccordionSummary>
                <AccordionDetails>
                <Divider />
                <Box component="form" onSubmit={handleTaskFormSubmit} sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Edit
                </Typography>
                <TextField
                    required
                    fullWidth
                    label="Task Name"
                    name="Name"
                    value={taskFormData.Name}
                    onChange={handleTaskFormChange}
                    margin="normal"
                />
                <TextField
                    required
                    fullWidth
                    label="Task Type"
                    name="Type"
                    value={taskFormData.Type}
                    onChange={handleTaskFormChange}
                    margin="normal"
                />
                <TextField
                    required
                    fullWidth
                    label="Command"
                    name="Command"
                    value={taskFormData.Command}
                    onChange={handleTaskFormChange}
                    margin="normal"
                />
                <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                    Submit
                </Button>
                <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={()=>{apiConfig.deleteTask(taskFormData.Id).then(response=>{console.log(response); retrieveTasks()})}}>
                    Delete
                </Button>
                </Box>
                </AccordionDetails>
            </Accordion>
        )
    }

    return(
        <Grid container display="flex" alignItems="center" justifyContent="center" direction="column" item xs={12} sm={12} md={4} lg={4} xl={4}>
            <p className={styles.font} style={{ fontSize: 20}}>Tasks</p>
            <Button variant="outlined" sx={{ width: "100%" }} onClick={handleAddTaskOpen}>+</Button>
            {
                tasks.map((task, index)=>{
                    return((renderTasks(task, index)))
                })
            }
        <AddTask handleClose={handleAddTaskClose} openAddTask={openAddTask} addTask={(task)=>{console.log(`Add task `, task); apiConfig.createTask(task).then((response)=>{console.log(response); retrieveTasks()});}}/>
        </Grid>
    )
}

export {Tasks}